<template>
  <div class="activeCheck">
    <van-tabs v-model="active" color="#007AFF" @click="onClick" title-active-color="#007AFF">
      <van-tab title="全部活动" name="a"></van-tab>
      <van-tab title="我参与的" name="b"></van-tab>
    </van-tabs>
    <div class="active-list">
      <van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="onLoad">
        <div
          class="active-item"
          v-for="(item, index) in activeList"
          :key="item.id || index"
          @click="toactiveView(item)"
        >
          <div class="active-top">
            <img class="active-img" :src="getImageSrc(item.eventPic)" alt="" />
            <div class="active-info">
              <div class="active-name p2-overflow">
                {{ item.eventName }}
              </div>
              <div class="active-time">{{ item.startDate }}~{{ item.endDate }}</div>
            </div>
          </div>
          <div class="active-bottom">
            <img class="active-icon" src="@/assets/image/activecheck/checkaddress.png" alt="" />
            <div class="active-address p2-overflow">
              {{ item.signAreas }}
            </div>
          </div>
          <div class="active-type" :class="`type-${item.status}`">
            {{ item.status == 2 ? '进行中' : item.status == 3 ? '已结束' : '未开始' }}
          </div>
        </div>
      </van-list>
    </div>
  </div>
</template>

<script>
import {getactiveAll, getjoinactive} from '@/api'
export default {
  data() {
    return {
      active: 'a',
      activeList: [],
      // 添加分页参数
      currentPage: 1,
      pageSize: 10,
      hasMore: true,
      loading: false,
      finished: false,
      // 用于区分不同tab的数据
      allActivities: [],
      myActivities: [],
      // 添加错误状态标识
      allActivitiesError: false,
      myActivitiesError: false
    }
  },

  components: {},

  methods: {
    toactiveView(val) {
      this.$router.push({
        path: '/activeView',
        query: {
          id: val.eventSignId
        }
      })
    },
    // Tab点击事件 - 切换时重置页码并重新加载数据
    onClick(name, title) {
      // 保存当前 tab 状态
      localStorage.setItem('activeTab', name)
      this.resetPagination()
      this.loadActivities()
    },
    // 重置分页参数
    resetPagination() {
      this.currentPage = 1
      this.activeList = []
      this.hasMore = true
      this.loading = false
      this.finished = false
      // 重置错误状态
      if (this.active === 'a') {
        this.allActivitiesError = false
      } else {
        this.myActivitiesError = false
      }
    },
    // 加载数据
    async loadActivities() {
      // 如果已经出现错误，则不再请求接口
      if ((this.active === 'a' && this.allActivitiesError) || (this.active === 'b' && this.myActivitiesError)) {
        this.loading = false
        this.finished = true
        return
      }

      if (!this.hasMore) return

      this.loading = true

      try {
        let activities = []

        if (this.active === 'a') {
          // 全部活动
          // 如果已有缓存数据，使用缓存
          if (this.allActivities.length > 0 && this.currentPage === 1) {
            activities = this.allActivities.slice(0, this.pageSize)
            this.hasMore = this.allActivities.length > this.pageSize
          } else {
            // 调用获取全部活动接口
            const params = {
              pageNo: this.currentPage,
              pageSize: this.pageSize
            }
            const response = await getactiveAll(params)
            activities = response.data || []
            // 如果是第一页，缓存所有数据
            if (this.currentPage === 1) {
              this.allActivities = response.allData || []
            }
          }
        } else {
          // 我参与的
          if (this.myActivities.length > 0 && this.currentPage === 1) {
            activities = this.myActivities.slice(
              (this.currentPage - 1) * this.pageSize,
              this.currentPage * this.pageSize
            )
            this.hasMore = this.myActivities.length > this.currentPage * this.pageSize
          } else {
            // 调用获取我参与的活动接口
            const params = {
              pageNo: this.currentPage,
              pageSize: this.pageSize
            }
            const response = await getjoinactive(params)
            activities = response.data || []
            // 如果是第一页，缓存所有数据
            if (this.currentPage === 1) {
              this.myActivities = response.allData || []
            }
          }
        }

        // 更新列表
        if (this.currentPage === 1) {
          this.activeList = activities
        } else {
          this.activeList.push(...activities)
        }

        // 判断是否还有更多数据
        this.hasMore = activities.length >= this.pageSize

        if (!this.hasMore) {
          this.finished = true
        } else {
          this.currentPage++
        }
        // 清除对应tab的错误状态
        if (this.active === 'a') {
          this.allActivitiesError = false
        } else {
          this.myActivitiesError = false
        }
      } catch (error) {
        console.error('加载活动数据失败:', error)
        this.$toast('数据加载失败')
        // 设置对应tab的错误状态
        if (this.active === 'a') {
          this.allActivitiesError = true
        } else {
          this.myActivitiesError = true
        }

        // 停止继续加载
        this.finished = true
      } finally {
        this.loading = false
      }
    },
    // 滚动加载触发的方法
    onLoad() {
      this.loadActivities()
    },
    getImageSrc(imgUrl) {
      return this.$isCdn(imgUrl) || require('@/assets/image/activecheck/active-base1.png')
    }
  },
  mounted() {
    const savedTab = localStorage.getItem('activeTab')
    if (savedTab) {
      this.active = savedTab
    }
    // this.loadActivities()
  }
}
</script>

<style lang="scss" scoped>
.activeCheck {
  .active-list {
    width: 100%;
    padding: 16px;
    .active-item {
      position: relative;
      width: 100%;
      min-height: 154px;
      background-color: #fff;
      border-radius: 8px;
      margin-bottom: 12px;
      padding: 16px;
      .active-top {
        display: flex;
        justify-content: space-between;
        margin-bottom: 12px;
        .active-img {
          width: 124px;
          height: 70px;
          border-radius: 6px;
          margin-right: 12px;
        }
        .active-info {
          flex: 1;
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          .active-name {
            font-size: 16px;
            font-weight: 500;
            color: #1a1a1a;
          }
          .active-time {
            font-size: 14px;
            color: #808080;
            font-weight: 400;
          }
        }
      }
      .active-bottom {
        min-height: 40px;
        padding: 10px 12px;
        background-color: #f8f8f8;
        border-radius: 4px;
        display: flex;
        .active-icon {
          width: 16px;
          height: 16px;
          margin-right: 5px;
        }
        .active-address {
          flex: 1;
          font-size: 14px;
          color: #808080;
        }
      }
      .active-type {
        display: flex;
        width: 52px;
        height: 21px;
        justify-content: center;
        align-items: center;
        font-size: 12px;
        color: #fff;
        border-radius: 8px 0px 8px 0px;
        position: absolute;
        left: 0;
        top: 0;
        &.type-2 {
          background-color: #17be6b;
        }
        &.type-1 {
          background-color: #007aff;
        }
        &.type-0 {
          background-color: #007aff;
        }
        &.type-3 {
          background-color: #86909c;
        }
      }
    }
  }
}
</style>
